import CAppDataGrid from '@/app/components/CAppDataGrid';
import AppFormatPercent from '@/app/features/format/AppFormatPercent';
import { Box, useTheme } from '@mui/material';
import React from 'react';
import { GridColDef, GridRowsProp, GridRenderCellParams } from '@mui/x-data-grid';
import { useTranslation } from 'react-i18next';
import investExpertiseAssetsTableListedAssets from '../../features/fund-type/langs/investExpertiseAssetsTableListedAssets';

import isoCountryCurrency from 'i18n-iso-countries';
import isoCountryCurrencyEN from 'i18n-iso-countries/langs/en.json';
import isoCountryCurrencyFR from 'i18n-iso-countries/langs/fr.json';

const customIsoCountryCurrencyFR = {
	...isoCountryCurrencyFR,
	countries: {
		...isoCountryCurrencyFR.countries,
		XX: 'International',
	},
};

const customIsoCountryCurrencyEN = {
	...isoCountryCurrencyEN,
	countries: {
		...isoCountryCurrencyEN.countries,
		XX: 'International',
	},
};

isoCountryCurrency.registerLocale(customIsoCountryCurrencyFR);
isoCountryCurrency.registerLocale(customIsoCountryCurrencyEN);

type CTableAssetsProps = {
	rows: GridRowsProp;
};

const CTableAssets = (props: CTableAssetsProps) => {
	const { rows } = props;

	const { t, i18n } = useTranslation();
	const theme = useTheme();
	const columns: GridColDef[] = [
		{
			field: 'name',
			headerName: t(investExpertiseAssetsTableListedAssets.name.tag),
			flex: 1,
			align: 'left',
			headerAlign: 'left',
			filterable: true,
			renderCell: (params: GridRenderCellParams) => <b>{params.value ?? '-'}</b>,
		},
		{
			field: 'country',
			headerName: t(investExpertiseAssetsTableListedAssets.country.tag),
			align: 'left',
			headerAlign: 'left',
			flex: 1,
			renderCell: (params: GridRenderCellParams) =>
				isoCountryCurrency.getName(params.value, i18n.language) ?? '-',
		},
		{
			field: 'businessSector',
			headerName: t(investExpertiseAssetsTableListedAssets.businessSector.tag),
			align: 'left',
			headerAlign: 'left',
			flex: 1,
			renderCell: (params: GridRenderCellParams) => params.value ?? '-',
		},
		{
			field: 'assetType',
			headerName: t(investExpertiseAssetsTableListedAssets.assetType.tag),
			align: 'left',
			headerAlign: 'left',
			flex: 1,

			renderCell: (params: GridRenderCellParams) => params.value ?? '-',
		},
		{
			field: 'weightInFund',
			headerName: t(investExpertiseAssetsTableListedAssets.weightInFund.tag),
			align: 'center',
			headerAlign: 'right',
			flex: 0.5,
			renderCell: (params: GridRenderCellParams) => {
				const v = Number(params.value);
				if (v < 0.0001 && v > 0) return '<0.01%';
				return <AppFormatPercent value={v} textIfNull="-" />;
			},
		},
	];

	return (
		rows && (
			<Box sx={{ height: 470, width: '100%', marginBottom: '15px' }}>
				<CAppDataGrid
					sx={{
						margin: '-10px',
						padding: '0 10px 0 10px',
						'*::-webkit-scrollbar': {
							height: '5px',
						},
						'*::-webkit-scrollbar-track': {
							backgroundColor: theme.palette.background.paper,
						},

						'*::-webkit-scrollbar-thumb': {
							backgroundColor: theme.palette.primary.main,
						},
					}}
					rows={rows}
					rowHeight={45}
					disableSelectionOnClick
					columns={columns}
				/>
			</Box>
		)
	);
};

export default CTableAssets;
